import React from "react";
import { useDispatch, useSelector } from 'react-redux';

import { selectMultiple, clearSelected } from 'reducers/Selected';

import { areAllAssetsSelected } from "selectors/Selected";

import { TYPES } from 'utils/constants';
import { buildAssetId } from 'utils/Assets';

import SelectAllCell from "widgets/grid/cells/SelectAllCell";

export default function SelectAllAssetsCell() {
	const dispatch = useDispatch();

	const { assets, isAllSelected } = useSelector(state => ({
		assets: state.assets.items,
		isAllSelected: areAllAssetsSelected(state),
	}));
	const allIds = assets.map(asset => buildAssetId(asset));

	const toggleSelectAll = () => {
		if (isAllSelected) {
			dispatch(clearSelected());
		} else {
			dispatch(selectMultiple(allIds, TYPES.ASSETS, true));
		}
	};

	return (
		<SelectAllCell
			className="select-all-assets"
			column={{ selectAll: toggleSelectAll, isAllSelected }}
		/>
	);
}
